import { FormState, FieldState } from 'formstate'
import { _ } from '../../utils/intl'
import { login, required } from '../../utils/forms'

class SignInForm {
  fields = {
    email: new FieldState('').validators(required, login),
    password: new FieldState('').validators(required),
  }

  form = new FormState(this.fields)

  serialize = () => {
    return {
      email: this.fields.email.$,
      password: this.fields.password.$,
    }
  }
}

export { SignInForm }
